// extracted by mini-css-extract-plugin
module.exports = {"freefrom":"FreeFrom_freefrom__nUXUW","button":"FreeFrom_button__d2yXg","title":"FreeFrom_title__UDFLT","list":"FreeFrom_list__7xqUP","listItem":"FreeFrom_listItem__Jhbj1"};